import React from 'react';
import { Tooltip, Button, Icon } from 'antd';

function RenderTooltipDetail({handleOnClick}) {
  return (
    <Tooltip title="Detail">
      <Button size="small" key="details" onClick={handleOnClick}>
        <Icon type="plus" />
      </Button>
    </Tooltip>
  );
}

export default RenderTooltipDetail;
